// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3eywO","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3-j4h"};